import { render, staticRenderFns } from "./fieldtype_text.vue?vue&type=template&id=2e541806&scoped=true&"
import script from "./fieldtype_text.vue?vue&type=script&lang=js&"
export * from "./fieldtype_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e541806",
  null
  
)

export default component.exports